import { createORPCClient } from "@orpc/client";
import type { ContractRouterClient } from "@orpc/contract";
import { OpenAPILink } from "@orpc/openapi-client/fetch";
import { createTanstackQueryUtils } from "@orpc/tanstack-query";
import { apiFetch } from "@packages/core-client/api/apiFetch.ts";
import { queryPath } from "@packages/core-client/query/queryKeys.ts";
import { useEnvironmentVariable } from "@squide/firefly";
import { useMemo } from "react";
import { companyContract } from "#shared/companyContract.ts";

function createCompanyClient(baseUrl: string) {
    const link = new OpenAPILink(companyContract, {
        url: `${baseUrl}/api/people/company`,
        fetch: apiFetch
    });

    const client: ContractRouterClient<typeof companyContract> = createORPCClient(link);
    const queryUtils = createTanstackQueryUtils(client, { path: queryPath("people", ["company"]) });

    return { client, queryUtils };
}

export function useCompanyClient() {
    const apiBaseUrl = useEnvironmentVariable("apiBaseUrl");

    return useMemo(() => createCompanyClient(apiBaseUrl), [apiBaseUrl]);
}
